import axios, { AxiosResponse } from "axios";

// import https from 'https'
import { proto } from "./orchestraProto.js";


import { GtfsLines, GtfsStopPoints } from "./gtfsTypes";
import {
  GtfsData,
  TransportMode,
  StopPoint,
  Dest,
  ApiColors
} from "./types";

import { Line } from "./types/line"

interface StringDict {
  [key: string]: string;
}

function callApi<T>(serverUrl: string, protoType: any): Promise<T> {
  return axios.request<any>({
    method: "get",
    url: serverUrl,
    responseType: 'arraybuffer',
    // httpsAgent: new https.Agent({ rejectUnauthorized: false }),
    // transformResponse: (resp) => protoType.decode(resp)
    transformResponse: (resp) => {
      resp = new Uint8Array(resp); // XXX pour la version es6, sinon erreur 'invalid buffer' 
      return protoType.decode(resp);
    }
  })
    .then((resp: AxiosResponse<T>) => {
      if (!resp.data) console.error("Orchestra error : no data");
      return resp.data;
    });
}

function gtfsGetInitData(
  gtfsUri: string,
  encodeUriPath: Boolean,
  network: string,
  area?: string,
  onlyPhysicals?: Boolean,
): Promise<GtfsData> {

  // Récupération des lignes
  let linesUrl = `/proto/lines-discovery-all?reseau=${network}`;
  let lignesFuture = callApi<proto.LinesApiResponse>(
    `${gtfsUri}${linesUrl}`, proto.LinesApiResponse
  ).then((data: proto.LinesApiResponse) => {
    let lines: { [key: string]: Line } = {};
    let lineOrder = 0;
    for (let rawLine of data.lines) {
      lineOrder += 1;
      let lineType = rawLine.type || 0;
      let order = rawLine.order || 0;
      let categ = rawLine.categ || "";
      let line: Line = new Line(
        rawLine.ref,
        rawLine.longname,
        rawLine.shortname,
        rawLine.color,
        rawLine.colortext,
        lineType,
        order,
        categ
      );
      lines[line.ref] = line;
    }
    return lines;
  });

  // Récupération des arrêts
  // let max = 50;
  // let stopsUrl = `/proto/stoppoints-discovery?reseau=${network}&max=${max}`;
  let stopsUrl = `/proto/stoppoints-discovery-all?reseau=${network}`;
  if (typeof onlyPhysicals !== 'undefined' && onlyPhysicals) {
    stopsUrl += `&onlyphysicals=1`;
  }
  let stopsFuture = callApi<proto.StopsApiResponse>(
    `${gtfsUri}${stopsUrl}`, proto.StopsApiResponse
  ).then((data: proto.StopsApiResponse) => {
    let stops: { [key: string]: StopPoint } = {};
    for (let rawStop of data.stops) {
      /**
       * Transforming datas from API and extract lines and dests
       */
      if (rawStop.name) {
        let x = null;
        let y = null;
        if (rawStop.location) {
          x = rawStop.location.latitude;
          y = rawStop.location.longitude;
        }
        let computedStop: StopPoint = {
          name: rawStop.name,
          x,
          y,
          ref: rawStop.ref,
          city: rawStop.city,
          lines: [],
          dests: [],
          isCommercial: false,
          spoints: []
        };
        if (rawStop.spoints && Array.isArray(rawStop.spoints) && rawStop.spoints.length > 0) {
          computedStop.isCommercial = true;
          for (let rawSpoint of rawStop.spoints) {
            let spoint: StopPoint = {
              name: computedStop.name,
              x: rawSpoint.latitude,
              y: rawSpoint.longitude,
              ref: rawSpoint.id,
              city: rawSpoint.city,
              lines: <string[]>[],
              dests: <Dest[]>[]
            };
            //Lines for now; waiting for update with destinations
            if (rawSpoint.lines) {
              for (let line of rawSpoint.lines) {
                for (let dest of line.dests) {
                  let destination: Dest = {
                    id: spoint.ref + line.id,
                    name: dest.lib,
                    service: line.ref,
                  };
                  spoint.dests.push(destination);
                }
                spoint.lines.push(line.ref);
              }
            }
            computedStop.spoints.push(spoint);
          }
        }
        let stopLines: string[] = [];
        if (rawStop.lines) {
          for (let line of rawStop.lines) {
            stopLines.push(line.ref || "");
            if (line.dests) {
              for (let dest of line.dests) {
                let destination: Dest = {
                  id: line.id,
                  name: dest.lib,
                  service: line.ref,
                };
                computedStop.dests.push(destination);
              }
            }
          }
        }
        computedStop.lines = stopLines;
        stops[computedStop.ref] = computedStop;
      }
    }
    return stops;
  });

  return axios
    .all([lignesFuture as Promise<any>, stopsFuture as Promise<any>])
    .then(
      axios.spread(function(lines, stops) {
        return {
          lines,
          stops
        };
      })
    );
}

export default async function(
  gtfsUri: string,
  encodeUriPath: Boolean,
  network: string,
  area?: string,
  onlyPhysicals?: Boolean,
): Promise<GtfsData> {
  return gtfsGetInitData(gtfsUri, encodeUriPath, network, area, onlyPhysicals);
}
